module.exports = __webpack_public_path__ + "img/questionnaire.f8ae5cfc.png";